<div class="action-container" *appHasRole="['Admin', 'Manager', 'Preparer']">
  <app-ag-action-icon-button
    iconClass="ic-notes-16"
    (action)="annotation()"
  />

  <app-ag-action-icon-button
    iconClass="ic-download-16"
    (action)="downloadCertificate()"
  />

  <div
    ngbDropdown
    class="dropdown d-inline-flex"
    container="body"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
  >
    <app-ag-action-icon-button
      ngbDropdownToggle
      iconClass="ic-more-horizontal-16"
    />

    <div ngbDropdownMenu class="common-dropdown-menu">
      @if (isEditTransactionVisible) {
        <button ngbDropdownItem class="dropdown-item" (click)="editTransaction()">
          <i class="icon ic-edit-20 mr-1"></i>
          <span>Edit</span>
        </button>
      }

      <button ngbDropdownItem class="dropdown-item" (click)="deleteTransaction()">
        <i class="icon ic-close-20 mr-1"></i>
        <span>Delete</span>
      </button>
    </div>
  </div>
</div>
